import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    standalone: false
})
export class PasswordInputComponent {
  @Input() dataTestId: string;
  @Input() errorMessage: string;
  @Input() formControlRef: FormControl;
  @Input() inputmode?: string = null;
  @Input() label: string;
  @Input() isFullWidth = false;

  hide = true;
}
